import { ModalComponent } from '../modal/modal.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Answer, Modal } from '../../../models/qa.model';
import { HistoryService } from '../../../services/history.service';
import { QaService } from '../../../services/qa.service';
import { StartupService } from '../../../services/startup.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  progress: string;
  lastAnswer: Answer;
  public modal: Modal;
  @ViewChild(ModalComponent) closeModalElem: ModalComponent;

  constructor(
    public startupService: StartupService,
    public qaService: QaService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit() {
    this.qaService.progress.subscribe(p => this.progress = p);
    this.modal = new Modal({
      Title: this.startupService.startupData.BrandInfo.WarningTitleTranslation,
      Text: this.startupService.startupData.BrandInfo.CloseWarningTranslation,
      ButtonText: this.startupService.startupData.BrandInfo.RedirectToHomeTranslation,
      Button2Text: this.startupService.startupData.BrandInfo.CloseModalTranslation,
      HideModal: true,
      ButtonClickFunction: () => {
        this.router.navigate(['/', window.location.href.split('/')[3], 'welcome']);
        this.modal.HideModal = true;
        this.modal.modalStatus(true);
        // window.location.href = '/' + window.location.href.split('/')[3];
      }
    });
  }
  showModal() {
    this.closeModalElem.modal.HideModal = false;
    this.closeModalElem.modal.modalStatus(false);
  }
  goBack() {
    // this.historyService.back();
    // window.history.back();
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/header/header.component.ts